/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPrinterIcon20Solid = forwardRef('TechPrinterIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 7V4a2 2 0 0 1 2-2h7.5a2 2 0 0 1 2 2v3H17a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1.25v1a2 2 0 0 1-2 2h-7.5a2 2 0 0 1-2-2v-1H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.25Zm1.5-3a.5.5 0 0 1 .5-.5h7.5a.5.5 0 0 1 .5.5v3h-8.5V4ZM16 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-9.75 2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h7.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-7.5Z" })));
});
